
import { defineComponent, ref, PropType } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { IndexedField } from '@/services/ContentService';

export default defineComponent({
  props: {
    fields: {
      type: Object as PropType<IndexedField[]>,
      required: false,
    },
    selection: {
      type: Object as PropType<IndexedField[]>,
      required: false,
    },
  },

  setup(props, { emit }) {
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const multiSortMeta = ref([
      // XIP on top
      { field: 'shortName', order: -1 },
      { field: 'displayName', order: 1 },
    ]);

    // shortNames.value = [...new Set(fields?.value?.value.map((v) => v.shortName))];
    // types.value = [...new Set(fields?.value?.value.map((v) => v.type))];

    const setSelection = (selection: IndexedField[]) => {
      // Avoid `ESLint: Unexpected mutation of "selection" prop.(vue/no-mutating-props)` when using
      // the shorthand `v-model:selection="selectedFields"`, or when changing the property in code
      // here. See also https://v3.vuejs.org/guide/component-basics.html#using-v-model-on-components
      emit('update:selection', selection);
    };

    return { filters, multiSortMeta, setSelection };
  },
});
